import { DriveStep, startTour, startTourOnFirstVisit } from "./tour";

// Step-by-step overlay for the restaurant POS. Steps are anchored on
// `data-tour="…"` attributes in RestaurantPOS.tsx.
const STEPS: DriveStep[] = [
  {
    popover: {
      title: "Willkommen an der Kasse",
      description:
        "Diese kurze Anleitung zeigt, wie eine Bestellung aufgenommen und bezahlt wird.",
    },
  },
  {
    element: '[data-tour="customer"]',
    popover: {
      title: "1. Kunde wählen",
      description:
        "Tippe auf das Personen-Symbol und wähle <b>Mitglied</b> oder <b>Gast</b>.<br/><br/>" +
        "Mitglieder bekommen den Mitgliederpreis und können auf ihr Konto buchen. " +
        "Ohne Auswahl wird als Gast mit Datum/Uhrzeit als Name verbucht.",
      side: "bottom",
    },
  },
  {
    element: '[data-tour="articles"]',
    popover: {
      title: "2. Artikel antippen",
      description:
        "Jeder Tipp auf einen Artikel fügt <b>1 Stück</b> zur Bestellung hinzu. " +
        "Die Artikel sind nach Kategorie (Getränke, Speisen, …) gruppiert.",
      side: "left",
    },
  },
  {
    element: '[data-tour="positions"]',
    popover: {
      title: "3. Bestellung prüfen",
      description:
        "Hier erscheinen die gewählten Artikel. Mit <b>+</b> / <b>−</b> änderst du die Menge, " +
        "mit dem Papierkorb entfernst du eine Position.",
      side: "right",
    },
  },
  {
    element: '[data-tour="total"]',
    popover: {
      title: "Gesamtbetrag",
      description: "Der zu bezahlende Betrag der aktuellen Bestellung.",
      side: "top",
    },
  },
  {
    element: '[data-tour="payment"]',
    popover: {
      title: "4. Bezahlen",
      description:
        "<b>Barzahlung</b> – Betrag kassieren und dann tippen. Die Bestellung ist damit abgeschlossen.<br/><br/>" +
        "<b>Auf Konto buchen</b> – nur bei Mitgliedern: der Betrag wird dem Mitgliedskonto belastet.<br/><br/>" +
        "<b>Tab offen lassen</b> – speichert die Bestellung, um später weitere Artikel hinzuzufügen oder zu bezahlen.",
      side: "top",
    },
  },
  {
    element: '[data-tour="new-order"]',
    popover: {
      title: "Offene Tabs & neuer Auftrag",
      description:
        "Offen gelassene Bestellungen erscheinen als Reiter oben und können jederzeit wieder geöffnet werden. " +
        "<b>Neuer Auftrag</b> startet eine leere Bestellung.",
      side: "bottom",
    },
  },
];

export function startRestaurantTour() {
  startTour(STEPS);
}

export function startRestaurantTourOnFirstVisit() {
  startTourOnFirstVisit("restaurantTourSeen", STEPS);
}
